export default "/template/resource//static/media/todo-empty-img.e944a180.png";